import navigationResource from '../../../locales/th/navigation.json';
import {
  DecorSubCategory,
  GuidesSubCategory,
  NewsPostSubCategory,
  PostSubcategory,
  PropertyResearchPostCategory,
} from '../domain/postCategories';
import {
  LandingPageTypes,
  LocationInsightSubLandingPageType,
} from '../domain/landingPages';

export function parsePropertyResearchPostCategory(
  categoryUrlParams: string,
): PropertyResearchPostCategory {
  const paramsToPostCategoryMap = new Map<string, PropertyResearchPostCategory>(
    [
      [
        navigationResource.landingPageRoutes.projectResearch.review,
        PostSubcategory.Review,
      ],
      [
        navigationResource.landingPageRoutes.projectResearch.preview,
        PostSubcategory.Preview,
      ],
      [
        navigationResource.landingPageRoutes.projectResearch.pov,
        PostSubcategory.PointOfView,
      ],
    ],
  );

  return paramsToPostCategoryMap.get(categoryUrlParams);
}

export function parseNewsPostSubCategory(
  categoryUrlParams: string,
): NewsPostSubCategory {
  const paramsToPostCategoryMap = new Map<string, NewsPostSubCategory>([
    [
      navigationResource.landingPageRoutes.news.propertyNews,
      PostSubcategory.PropertyNews,
    ],
    [
      navigationResource.landingPageRoutes.news.generalNews,
      PostSubcategory.GeneralNews,
    ],
  ]);

  return paramsToPostCategoryMap.get(categoryUrlParams);
}

export function parseGuidesPostSubCategory(
  categoryUrlParams: string,
): GuidesSubCategory {
  const paramsToPostCategoryMap = new Map<string, GuidesSubCategory>([
    [
      navigationResource.landingPageRoutes.guides.investment,
      PostSubcategory.Investment,
    ],
    [
      navigationResource.landingPageRoutes.guides.finance,
      PostSubcategory.Finance,
    ],
    [
      navigationResource.landingPageRoutes.guides.buyAndSell,
      PostSubcategory.BuyAndSell,
    ],
  ]);
  return paramsToPostCategoryMap.get(categoryUrlParams);
}

export function parseDecorPostSubCategory(
  categoryUrlParams: string,
): DecorSubCategory {
  const paramsToPostCategoryMap = new Map<string, DecorSubCategory>([
    [
      navigationResource.landingPageRoutes.decor.renovation,
      PostSubcategory.Renovation,
    ],
    [
      navigationResource.landingPageRoutes.decor.maintenance,
      PostSubcategory.Maintenance,
    ],
    [
      navigationResource.landingPageRoutes.decor.interiorInspiration,
      PostSubcategory.InteriorInspiration,
    ],
  ]);
  return paramsToPostCategoryMap.get(categoryUrlParams);
}

export function parseLocationInsightSubLandingPageType(
  param: string,
): LocationInsightSubLandingPageType {
  if (
    param === navigationResource.landingPageRoutes.locationInsight.trainline
  ) {
    return LandingPageTypes.TrainlinesPage;
  } else if (
    param === navigationResource.landingPageRoutes.locationInsight.zone
  ) {
    return LandingPageTypes.ZonesPage;
  }
}
